module.exports = __webpack_public_path__ + "assets/images/cockpit/inactive/btn_summary-inactive_ru.png";